import { render, staticRenderFns } from "./InfoArea.vue?vue&type=template&id=36bd2444&scoped=true"
import script from "./InfoArea.vue?vue&type=script&lang=js"
export * from "./InfoArea.vue?vue&type=script&lang=js"
import style0 from "./InfoArea.vue?vue&type=style&index=0&id=36bd2444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bd2444",
  null
  
)

export default component.exports